// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1g1m_","upload":"Small_upload__2LRYb","imageWrap":"Small_imageWrap__cfxkq","removeBtn":"Small_removeBtn__1JXD6"};